import BigNumber from 'bignumber.js';
import { ComputedReserveData } from '../hooks/app-data-provider/useAppDataProvider';
import { getMaxLeverage } from './getMaxLeverage';
import { getBorrowApy } from './getBorrowApy';

export const calculateApr = (
  poolApr: BigNumber,
  token: ComputedReserveData,
  globalRevenueFee?: BigNumber,
): BigNumber => {
  const maxLeverage = getMaxLeverage(token);
  const borrowApy = getBorrowApy(token);
  const poolAprWithFee = poolApr.multipliedBy(BigNumber(10000).minus(globalRevenueFee || 0)).dividedBy(10000);
  return poolApr.plus(poolAprWithFee.minus(borrowApy).multipliedBy(maxLeverage.minus(1)));
}
